import { PlanTypeEnumSchema } from "@backend/src/schemas/enums";
export type PlanType = {
  name: string;
  price: number;
  maxProjects: number;
  maxProjectManagers: number;
  maxProjectMembers: number;
  features: string[];
};
export function planTypeAllow(
  plan: keyof typeof PlanTypeEnumSchema | "FREE" | null,
  currentUsage: { projects: number; managers: number; members: number },
  validate: "project" | "manager" | "member" | "canCreate" | "admin",
  selectedPlan: PlanType
) {
  if (!selectedPlan && plan) {
    throw new Error("Invalid plan selected");
  }

  const { maxProjects, maxProjectManagers, maxProjectMembers } = selectedPlan;

  const { projects, managers, members } = currentUsage;

  if (
    managers + members > maxProjectManagers + maxProjectMembers &&
    validate == "canCreate"
  ) {
    return {
      valid: false,
      message: `You have exceeded the project member limit of {{${maxProjectMembers-1}}} for the {{${selectedPlan.name}}} plan.`,
    };
  }
  if (projects >= maxProjects && validate == "project") {
    return {
      valid: false,
      message: `You have exceeded the project limit of {{${maxProjects}}} for the {{${selectedPlan.name}}} plan.`,
    };
  }

  if (managers >= maxProjectManagers && validate == "manager") {
    return {
      valid: false,
      message: `You have exceeded the manager limit of {{${maxProjectManagers}}} for the {{${selectedPlan.name}}} plan.`,
    };
  }

  if (members >= maxProjectMembers && validate == "member") {
    return {
      valid: false,
      message: `You have exceeded the project member limit of {{${maxProjectMembers-1}}} for the {{${selectedPlan.name}}} plan.`,
    };
  }
  if (plan !== "ENTERPRISE" && validate == "admin") {
    return {
      valid: false,
      message: `Your current plan does not support adding additional admins. Please upgrade to the Enterprise plan to add more admins.`,
    };
  }
  return { valid: true };
}
